<ul class="breadcrumb">
  <li><a [routerLink]="['/home']"><span class="color-soft-grey-axial">ESTÁS EN </span>Inicio</a></li>
  <li><i class="pi pi-angle-right"></i></li>
  <li><a [routerLink]="['/imports']">Importar datos</a></li>
</ul>
<p-card class="p-md-12">
  <ng-template pTemplate="header">
    <div class="p-card-title">
      Filtros
      <div class="p-card-title-actions">
        <a (click)="clearFilters()">Limpiar filtros</a>
        <a (click)="search()"><i class="fas fa-search"></i>&nbsp;Buscar </a>
      </div>
    </div>
  </ng-template>
  <div class="p-grid">
    <div class="p-col p-field">
      <label for="name">Nombre</label>
      <input id="name" type="text" pInputText [(ngModel)]="filters.filename" />
    </div>
  </div>
</p-card>
<p-card styleClass="p-card-content-fit">
  <ng-template pTemplate="header">
    <div class="p-card-title">
      Histórico de importación
      <div class="p-card-title-actions">
        <a (click)="add()"><fa-icon [icon]="['fas', 'plus-circle']"></fa-icon> Importar</a>
      </div>
    </div>
  </ng-template>


  <p-table #grid [value]="imports" [lazy]="true" (onLazyLoad)="loadData($event)" [loading]="loading" [paginator]="true"
    [rows]="10" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
    currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
    [rowsPerPageOptions]="[5,10,25,50]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="status" width="110" style="text-align: center;">status</th>
        <th pSortableColumn="date" width="120" style="text-align: center;">Fecha</th>
        <th pSortableColumn="entity_id" width="100">Entidad</th>
        <th pSortableColumn="createdBy.name" width="120">Creado Por</th>
        <th pSortableColumn="filename" width="100">Nombre</th>
        <!--<th pSortableColumn="filename">Nombre fichero</th>-->
        <th width="100"></th>
        <th width="100"></th>
        <th width="100"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-import>
      <tr>
        <td width="120" style="text-align: center;">
          <span class="custom-marker badge badge-danger" *ngIf="import.status=='fail'">Fallo</span>
          <span class="custom-marker badge badge-success" *ngIf="import.status=='success'">Correcto</span>
          <span class="custom-marker badge badge-warning" *ngIf="import.status=='pending'">Pendiente</span>
          <span class="custom-marker badge badge-info"
            *ngIf="import.status=='processing' || import.status=='inProcess' || import.status=='validated'">Procesando
            {{(import.status_line*100/import.status_total_lines) | number : '0.0-0' }}%</span>
          <span class="custom-marker badge badge-primary" *ngIf="import.status=='validating'">Pdto. de validación</span>
        </td>
        <td width="140"> {{import.date | date: 'dd/MM/yyyy HH:mm'}}</td>
        <td width="120">{{import.entity?.name}}</td>
        <td>{{import.createdBy?.name}}</td>
        <td>{{import.name}}</td>
        <!-- <td>{{import.filename}}</td>-->
      <td class="grid-actions" width="120">

        <button pButton style="background-color: #e42728 !important" *ngIf="import.status=='fail'"
                (click)="openInfo(import)" [disabled]="import.status!='validating' && import.status!='fail'"
                icon="pi pi-exclamation-triangle" label="Error"></button>
        <button pButton class="p-button-secondary" *ngIf="import.status=='validating'" (click)="openInfo(import)"
                [disabled]="import.status!='validating' && import.status!='fail'" icon="pi pi-check"
                label="Validar"></button>
        <button pButton class="p-button-secondary" *ngIf="import.status=='success'" (click)="openInfo(import)"
                icon="pi pi-info-circle"></button>
      </td>
        <td class="grid-actions" width="120">
          <button pButton (click)="add(import.id)"
            [disabled]="import.status=='processing'||import.status=='inProcess'||import.status=='validated'"><fa-icon
              [icon]="['far', 'edit']"></fa-icon> Reutilizar</button>
        </td>
        <td class="grid-actions" width="100">
          <button pButton (click)="delete(import)" class="p-button-danger"><fa-icon [icon]="['far', 'trash-alt']"></fa-icon> Borrar</button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-card>
